export function checkUtxos(utxoIds, utxos) {
    const walletUtxoMap = new Map();
    for (const utxo of utxos) {
        walletUtxoMap.set(`${utxo.txid}:${utxo.vout}`, utxo);
    }
    const result = [];
    const absent = [];
    for (const id of utxoIds) {
        const key = `${id.txid}:${id.vout}`;
        const utxo = walletUtxoMap.get(key);
        if (utxo) {
            result.push(utxo);
        }
        else {
            absent.push(id);
        }
    }
    if (absent.length) {
        const absentString = absent
            .map((val) => `${val.txid}:${val.vout}`)
            .join(", ");
        throw Error(`Utxos [${absentString}] not found in wallet`);
    }
    return result;
}
//# sourceMappingURL=checkUtxos.js.map